module.exports = __webpack_public_path__ + "static/media/Country_Club_Vlg_II_Part_1.8015afeb.pdf";